import { Avatar } from "@mui/material";
import dayjs from "dayjs";
import { getTimeZoneAbbreviation } from "../../../../../utils/getTimeZoneAbbreviation";
import BaseRating from "../../../../../components/ui/BaseRating";
import { PaymentType } from "../../../../../utils/enum";

const JobsCompletedCard = ({ jobsCompleted }) => {
  const workOrder = jobsCompleted?.workOrder;
  return (
    <div className="grid grid-cols-[1fr_auto] gap-x-6 mb-4">
      <div className="flex items-start gap-4">
        <Avatar src={workOrder?.company?.digitalAssets[0]?.url} sx={{ width: 50, height: 50 }} />

        <div>
          <h6 className="flex font-normal items-center gap-x-7 !text-primary capitalize">
            {workOrder?.title}
            <span className="text-md font-medium">
              <BaseRating rating={workOrder?.rating} />
            </span>
          </h6>

          <div className="flex items-center mt-1 flex-wrap gap-x-6 gap-y-1">
            <p className="text-[#525354] text-sm font-poppins">
              <i className="fa-solid fa-location-dot mr-1"></i>
              {workOrder?.address?.addressLine1}
            </p>

            <p className="text-primary text-sm">
              <i className="fa-light fa-car mr-1"></i>
              {workOrder.distance ? workOrder.distance.toFixed(2) : "0.00"} km
            </p>
          </div>

          {workOrder?.services?.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-3">
              {workOrder.services.map((service, index) => (
                <p key={index} className="font-light bg-[#F6F6F6] rounded-sm px-3 py-[4px] w-fit">
                  {service?.services?.subCategory}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-col items-end text-sm whitespace-nowrap gap-2">
        <p className="leading-tight">
          {dayjs(workOrder?.orderStartDate).format("MM/DD/YYYY")}
          <span> at </span>
          {dayjs.utc(workOrder?.orderStartTime).format("hh:mm A")}
          <span> ({getTimeZoneAbbreviation(workOrder?.timeZone) || ""})</span>
        </p>

        <div>
          <p className="table-font-size text-primary font-medium">
            {PaymentType[workOrder?.engineerPaymentType]}
          </p>
        </div>
      </div>
    </div>
  );
};

export default JobsCompletedCard;
